import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import colors from "../../../../../utils/colors";

const PageHeader = ({ title, description, actions }) => {
  return (
    <Box sx={{ mb: 6 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack spacing={1}>
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: 600,
              color: colors.neutral[900],
              lineHeight: "32px",
            }}
          >
            {title}
          </Typography>
          {description && (
            <Typography
              sx={{
                fontSize: 14,
                color: colors.neutral[600],
                lineHeight: "21px",
              }}
            >
              {description}
            </Typography>
          )}
        </Stack>
        {actions && (
          <Stack direction="row" spacing={3}>
            {actions}
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default PageHeader;
